import {
  ActionMenu,
  Button,
  Pill,
  Table,
  TableBody,
  TableHead,
  TableHeader,
  TableRow,
} from '@/shared/components';
import { formatDate } from '@/shared/lib/format';
import type { CompanyResponse } from '@/shared/api';
import { COMPANY_TYPE_LABELS } from './CompanyFormDialog';
import { CompanyRow, companyRowActions, type CompanyRowHandlers } from './CompanyRow';

interface Props extends CompanyRowHandlers {
  companies: CompanyResponse[];
}

/**
 * Firmen als Tabelle, unterhalb der gemessenen Breite als gestapelte Karte.
 *
 * <p>Container-Query statt Viewport-Breakpoint: die Seite liegt im Einstellungs-Layout und ist
 * dort auch auf einem großen Bildschirm schmal (Lehre aus Block D).</p>
 */
export function CompaniesList({ companies, ...handlers }: Props) {
  return (
    <div className="@container">
      <div className="@2xl:block hidden">
        <Table>
          <TableHeader>
            <TableRow>
              <TableHead>Firma</TableHead>
              <TableHead>Art</TableHead>
              <TableHead>Angelegt</TableHead>
              <TableHead className="text-right">
                <span className="sr-only">Aktionen</span>
              </TableHead>
            </TableRow>
          </TableHeader>
          <TableBody>
            {companies.map((c) => (
              <CompanyRow key={c.id} company={c} {...handlers} />
            ))}
          </TableBody>
        </Table>
      </div>

      <ul className="@2xl:hidden grid gap-3">
        {companies.map((c) => (
          <li key={c.id} className="border-line bg-card shadow-card rounded-lg border p-4">
            <div className="flex flex-wrap items-start justify-between gap-2">
              <div className="min-w-0">
                <p className="text-ink wrap-break-word font-serif text-lg">{c.name}</p>
                <p className="text-ink-faint wrap-break-word mt-0.5 font-mono text-xs">{c.slug}</p>
              </div>
              <Pill variant="default" size="sm">
                {COMPANY_TYPE_LABELS[c.type]}
              </Pill>
            </div>
            <p className="text-ink-soft mt-3 text-xs tabular-nums">
              Angelegt am {formatDate(c.createdAt)}
            </p>
            <ActionMenu
              className="mt-3 block w-full"
              trigger={
                <Button variant="ghost" className="border-line min-h-11 w-full border">
                  Aktionen
                </Button>
              }
              items={companyRowActions(c, handlers)}
            />
          </li>
        ))}
      </ul>
    </div>
  );
}
